import React, { useState } from "react";
import "../Gallery.css";
import config from "../config";

function Gallery({ images }) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openOverlay = (index) => {
    setCurrentIndex(index);
    setIsOpen(true);

  };

  const closeOverlay = () => setIsOpen(false);

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <div className="gallery">
      {/* Thumbnails */}
      {images.map((img, index) => (
        <img
          key={index}
          src={config.BaseUrl+img}
          alt={`Bild ${index + 1}`}
          className="thumbnail"
          loading="lazy"
          onClick={() => openOverlay(index)}
        />
      ))}

      {/* Overlay */}
      {isOpen && (
        <div className="overlay">
          <button className="close" onClick={closeOverlay}>×</button>
          <button className="prev" onClick={prevImage}>‹</button>
          <img
            src={config.BaseUrl+images[currentIndex]}
            alt={`Bild ${currentIndex + 1}`}
            className="overlay-image"
          />
          <button className="next" onClick={nextImage}>›</button>
        </div>
      )}
    </div>
  );
}

export default Gallery;
